const BahrainSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_4152_110842)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#F0F0F0"
      />
      <path
        d="M19.9996 0C15.9858 0 12.249 1.1832 9.11678 3.21859L14.2604 6.66617L7.82568 9.99945L14.2604 13.3327L7.82568 16.666L14.2604 19.9989L7.82568 23.3321L14.2604 26.6653L7.82568 29.9989L14.2604 33.3322L9.11615 36.7809C12.2485 38.8166 15.9856 40 19.9996 40C31.0452 40 39.9996 31.0456 39.9996 20C39.9996 8.95437 31.0452 0 19.9996 0V0Z"
        fill="#D80027"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_110842">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default BahrainSvg;
